import React from 'react'
import { Button, Modal } from 'react-bootstrap'
import styled from 'styled-components'

const Styled = styled.div`
  .modal-title {
    font-size: 22px;
    font-weight: bold;
    color: #404040;
    padding-left: 40px;
    margin: auto;
  }

  .modal-header {
    padding-top: 10px;
    height: 85px;
    border-bottom: none;
  }

  .modal-header button {
    margin: 0 !important;
    margin-right: 20px !important;
    font-size: 10px;
    padding: 10px;
    border: 1px solid rgb(0, 0, 0, 0.5);
    border-radius: 50%;
  }

  .modal-body {
    color: rgb(0, 0, 0, 0.6);
    font-size: 18px;
    padding: 0px 30px 20px;
    text-align: center;
  }

  .archive-warning-cancel-btn {
    font-size: 18px;
    font-weight: 700;
    padding: 10px;
    margin: 15px auto;
    width: auto;
    border: 1px solid rgb(0, 0, 0, 0.3);
  }

  .archive-warning-cancel-btn:hover {
    opacity: 0.7;
    border: 1px solid rgb(0, 0, 0, 0.3);
  }

  .archive-warning-continue-btn {
    font-size: 18px;
    font-weight: 700;
    padding: 10px;
    margin: 15px auto;
    width: auto;
    border: none;
    color: #00bca8;
  }

  .archive-warning-continue-btn:hover {
    color: #00bca8;
    opacity: 0.7;
  }
`

export const ArchiveDeleteWarningModal = ({ show, onCancel, onContinue }) => {
  return (
    <Modal show={show} centered={true} onHide={onCancel} size="lg">
      <Styled>
        <Modal.Header closeButton>
          <Modal.Title>Data archive in progress</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          A data archive is in process. If you delete your account before it
          finishes, you will not be able to access the data archive.
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="light"
            className="archive-warning-cancel-btn"
            onClick={onCancel}>
            Cancel
          </Button>
          <Button
            variant="link"
            className="archive-warning-continue-btn"
            onClick={onContinue}>
            Continue deleting account
          </Button>
        </Modal.Footer>
      </Styled>
    </Modal>
  )
}

export default ArchiveDeleteWarningModal
